<template>
  <div class="footer my-footer">
    <!-- <div> -->
      <img :src="logo" alt="" class="logo" style="height: auto;width: 118px;height: 32px;">
    <!-- </div> -->
      <a @click="handleAgreement" style="cursor: pointer;" rel="nofollow" target="_blank">
        用户协议
      </a>
      <a @click="handlePrivacy" style="cursor: pointer;" rel="nofollow" target="_blank">
        隐私政策
      </a>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" rel="nofollow noopener noreferrer" target="_black">
        苏ICP备2023057581号-1
      </a>
      <a href="" target="_blank">
        版权所有：苏州极光数据有限公司
      </a>
      <span>
        友情链接：
        <a target="_blank" href="http://jiguangcloud.com/">
          极光云
        </a>
<!--        <a target="_blank" href="">
          商机网
        </a>
        <a target="_blank" href="">
          知了标讯
        </a>-->
      </span>
    </div>
</template>

<script>
export default {
  name: 'footers',

  data() {
    return {
      logo: 'https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/static/logo/logo-footer.png',
    }
  },

  mounted() {},

  methods: {
    handleAgreement() {
      this.$router.push({path:'/agreement'});
    },
    handlePrivacy() {
      this.$router.push({path:'/privacy'});
    },
  }

}
</script>

<style scoped>
.my-footer {
  display: block;
  line-height: 3vw;
}
.my-footer>a:before,.my-footer>span:before {
  height: 1vw;
  width: 0.1vw;
}
.my-footer a {
  font-size: 1vw;
  padding: 0 1vw;
}
.my-footer span {
  font-size: 1vw;
  padding: 0 1vw;
}
.my-footer img {
  padding: 0 1vw;
}
</style>



// WEBPACK FOOTER //
// src/views/homePage/footers.vue